package pl.decks.chartjs.model

sealed class JSScriptableIndexable<T> {
    data class Static<T>(val value: T) : JSScriptableIndexable<T>()
    data class PerPoint<T>(val values: List<T>) : JSScriptableIndexable<T>()
    data class Scriptable<T>(val fn: (dynamic) -> T) : JSScriptableIndexable<T>()
    data class TypedScriptable<C, T>(val fn: (C) -> T) : JSScriptableIndexable<T>()

    internal fun toChartJs(transform: (T) -> dynamic): dynamic =
        when (this) {
            is Static -> transform(value)
            is PerPoint -> values.map { transform(it) }.toTypedArray().asDynamic()
            is Scriptable -> fn.asDynamic()
            is TypedScriptable<*, T> -> fn.asDynamic()
        }

}
